import React from 'react';
import {connect} from 'react-redux';
import {Container, Row} from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import {utilActions} from '../../_actions';
import MaterialTable from 'material-table';
import {FormEmpresa} from './forms/FormEmpresa';
import {EmpresaDP} from '../../_helpers';
import {empresaActions} from '../../_actions/empresa.actions';
import ReactTooltip from 'react-tooltip';

class AdmEmpresa extends React.Component {

    state = {
        show: false,
        empresa: {}
    };

    handleClose = () => {
        this.setState({
            show: false,
            empresa: {}
        });
        this.props.traerEmpresas();
    };

    editar = (empresa) => {
        this.setState({
            show: true,
            empresa: empresa
        });
    };

    nuevo = () => {
        this.setState({
            show: true
        });
    };

    componentDidMount() {
        if (this.props.empresas === undefined) this.props.traerEmpresas();
    }

    render() {
        const {empresas} = this.props;
        const header = [
            {title: 'Id', field: 'id'},
            {title: 'Nombre', field: 'nombre'},
            {
                title: 'Acciones', cellStyle: {width: '30%'},
                render: row =>
                    <>  <a data-tip data-for='editar' className="btns btns-link" onClick={() => this.editar(row)}>
                        <span className="material-icons text-recursos">edit</span>
                        </a>
                        <ReactTooltip place="bottom" id='editar' aria-haspopup='false' >
                        <span>Editar Empresa</span>
                        </ReactTooltip>
                    </>
            }
        ];

        const options = {
            search: true,
            sorting: true
        }

        return (
            <div className="main-content">
                <Container fluid>
                    <Row className="mb-5 mt-5">
                        <Col xs="12">
                            <button className="btns btns-iot text-white" onClick={() => this.nuevo()}>
                                <i className="material-icons-outlined icon-image-preview align-top">person_add</i> Nueva
                                empresa
                            </button>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs="12">
                            <MaterialTable
                                title='Empresas'
                                columns={header}
                                data={empresas}
                                options={options}
                                localization={utilActions.traerPalabrasTabla()}
                                detailPanel={rowData => {
                                    return (
                                        <EmpresaDP rowData={rowData}/>
                                    )
                                }}
                            />

                        </Col>
                    </Row>
                </Container>

                {this.state.show &&
                <FormEmpresa show={this.state.show} empresa={this.state.empresa} handleClose={this.handleClose}/>}
            </div>
        );
    }
}

function mapState(state) {
    const {empresas} = state.empresa;
    return {empresas};
}

const actionCreators = {
    traerEmpresas: empresaActions.traerEmpresas
}

const connectedAdmEmpresa = connect(mapState, actionCreators)(AdmEmpresa);
export {connectedAdmEmpresa as AdmEmpresa};